module.exports = __webpack_public_path__ + "static/media/camtarte-1.574e8fb5.png";